import React, { Component } from 'react'

import classes from './SetupLevel.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import Form from '../../../../components/PageContent/SetupData/SetupLevel/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import ActionBar from '../../../../components/ActionBar/ActionBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox, Chip } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupLevel extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    importModalOpen: false,
    importFile: '',
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      seq_no: {
        label: this.props.translate('seqNo'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('seqNo')
        },
        value: '',
        validation: {
          required: true,
          isDecimal: true,
          isOverInt: true
        },
        valid: false,
        touched: false,
        error: null
      },
      level_name: {
        label: this.props.translate('levelName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('levelName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalType')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      parent_level_id: {
        label: this.props.translate('parentLevel'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('parentLevel'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('parentLevel')
            }
          ],
          disabled: true
        },
        value: {},
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('levelGroup')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      midpoint: {
        label: this.props.translate('midpoint'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('midpoint')
        },
        value: '',
        validation: {
          required: true,
          isNumeric: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_group_id: {
        label: this.props.translate('positionGroup'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('positionGroup'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('positionGroup')
            }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      level_tag: {
        label: this.props.translate('tag'),
        elementType: 'newmultiSelect',
        elementConfig: {
          options: [],
          freeSolo: true,
          renderTags: (value, getTagProps) =>
            value.map((option, index) => <Chip label={option} {...getTagProps({ index })} />)
        },
        value: [],
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_district: {
        label: this.props.translate('district'),
        elementType: 'checkbox',
        value: false,
        validation: false,
        valid: true
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: false,
        valid: true
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalType')
            }
          ]
        }
      },
      level_id: {
        label: this.props.translate('levelName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelName'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('levelName') }
          ]
        }
      },
      // parent_level_id: {
      //   label: this.props.translate('parentLevel'),
      //   value: '',
      //   configs: {
      //     placeholder: this.props.translate('select') + this.props.translate('parentLevel'),
      //     options: [
      //       {
      //         value: '',
      //         label: this.props.translate('select') + this.props.translate('parentLevel')
      //       }
      //     ]
      //   }
      // },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('active'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('active') }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      levelGroupOptions: this.props.levelGroupOptions,
      appraisalTypeOptions: this.props.appraisalTypeOptions,
      parentLevelOptions: this.props.parentLevelOptions,
      postionGroupOptions: this.props.postionGroupOptions,
      filterCompany: this.props.filterCompany,
      filterLevel: this.props.filterLevel,
      filterAppraisalType: this.props.filterAppraisalType,
      filterActive: this.props.filterActive,
      filterParentLevel: this.props.filterParentLevel,
      tagOptions: this.props.tagOptions
    }
  }
  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('level'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('level'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.level_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('level'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.level_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    { field: 'seq_no', title: this.props.translate('seqNo'), type: 'string' },
    { field: 'level_name', title: this.props.translate('appraisalLevel'), type: 'string' },
    { field: 'appraisal_type_name', title: this.props.translate('appraisalType'), type: 'string' },
    { field: 'parent_name', title: this.props.translate('parentName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('companyName'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchLevel()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
    if (prevprops.selectedRecord !== this.props.selectedRecord) {
      if (this.props.selectedRecord) {
        const filter = {
          company_id: this.props.selectedRecord.company_id,
          appraisal_type_id: this.props.selectedRecord.appraisal_type_id
        }

        this.props.fetchParentLevelOptions(filter)
      }
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
    }

    if (props.levelGroupOptions !== updateProps.levelGroupOptions) {
      updateOptions('level_group_id', 'levelGroupOptions', [
        'level_group_id',
        'level_group_name',
        'Select Level Group'
      ])
    }

    if (props.appraisalTypeOptions !== updateProps.appraisalTypeOptions) {
      updateOptions('appraisal_type_id', 'appraisalTypeOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' },
        'Select Appraisal Type'
      ])
      updateFilter('appraisal_type_id', 'appraisalTypeOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' }
      ])
    }
    if (props.parentLevelOptions !== updateProps.parentLevelOptions) {
      updateOptions('parent_level_id', 'parentLevelOptions', [
        'level_id',
        'level_name',
        'Select Parent'
      ])

      // updatedState.inputGroups.parent_level_id.elementConfig.disabled = false
      // updatedState.inputGroups.parent_level_id.value = getSelectvalue(
      //   updatedState.inputGroups.parent_level_id.value,
      //   props.parentLevelOptions.map(item => ({
      //     key: item.level_id,
      //     value: item.level_id,
      //     label: item.level_name
      //   }))
      // )
    }

    if (props.postionGroupOptions !== updateProps.postionGroupOptions) {
      updateOptions('position_group_id', 'postionGroupOptions', [
        'position_group_id',
        { code: 'position_group_code', name: 'position_group_name' },
        'Select Position Group Name'
      ])
    }
    if (props.filterCompany !== updateProps.filterCompany) {
      updateFilter('company_id', 'filterCompany', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.tagOptions !== state.tagOptions) {
      let inputForms = state.inputGroups
      let targetFormItem = inputForms.tags
      let updatedFormItem = {
        ...targetFormItem,
        elementConfig: { ...targetFormItem.elementConfig, options: props.tagOptions }
      }

      const updatedInputGroup = updateObject(inputForms, { tags: updatedFormItem })
      updatedState = updateObject(updatedState, {
        inputGroups: updatedInputGroup,
        tagOptions: props.tagOptions
      })
    }
    if (props.filterLevel !== updateProps.filterLevel) {
      updateFilter('level_id', 'filterLevel', ['level_id', 'level_name'])
    }
    // if (props.filterParentLevel !== updateProps.filterParentLevel) {
    //   updateFilter('parent_level_id', 'filterParentLevel', ['parent_level_id', 'parent_level_name'])
    // }

    if (props.filterActive !== updateProps.filterActive) {
      updateFilter('is_active', 'filterActive', ['active_code', 'active_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newLevelData = Object.entries(state.inputGroups).reduce((levelGroups, level) => {
        let [levelKey, levelAttrs] = level
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (levelAttrs.elementType === 'checkbox') {
          value = false
        }
        if (!levelAttrs.validation || !levelAttrs.validation.required) {
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[levelKey]) {
          value = props.selectedRecord[levelKey]

          let { isValid, error } = checkValidity(value, levelAttrs.validation, levelAttrs.label)

          if (levelAttrs.elementType === 'newselect') {
            value =
              state.inputGroups[levelKey].elementConfig.options.find(res => res.value === value) ||
              value
          }
          if (levelAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newLevelAttrs = {
          ...levelAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(levelGroups, { [levelKey]: { ...newLevelAttrs } })
      }, {})

      newLevelData = updateObject(newLevelData, {
        parent_level_id: {
          ...newLevelData.parent_level_id,
          elementConfig: {
            ...newLevelData.parent_level_id.elementConfig,
            disabled: false
          }
        }
      })

      updatedState = {
        ...updatedState,
        formValid: true,
        inputGroups: newLevelData,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchLevel(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchLevel(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }

  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'tags':
          newFormAttrs = {
            ...formAttrs,
            value: []
          }
          break

        case 'is_district':
          newFormAttrs = {
            ...formAttrs,
            value: false
          }

          break
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }

          break

        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    if (this.state.addAno) {
      this.setState({
        inputGroups: newFormData,
        addAno: false
      })
    } else {
      this.setState({
        inputGroups: newFormData,
        modalOpen: false
      })
    }
  }
  openModalHandler = (action, recordId) => {
    this.setState({
      action: action,
      actionRecordId: recordId
    })
    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
    if (recordId && action === 'edit') {
      this.props.fetchLevelById(recordId)
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false,
        formValid: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    this.setState({
      actionRecordId: null,
      formValid: false
      // modalOpen: false
    })
  }

  downloadHandler = () => {
    this.props.downloadTemplate(this.state.filter)
  }

  exportHandler = () => {
    this.props.exportLevel(this.state.filter)
  }
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: ''
    })
  }

  fileChangeHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  fileSubmitHandler = () => {
    this.props.importLevel(this.state.importFile, this.state.filter)
    this.closeImportModal()
  }

  levelSubmitHandler = type => {
    let levelData = Object.entries(this.state.inputGroups).reduce((levelData, levelEntry) => {
      let [levelKey, levelAttrs] = levelEntry
      let value = ''
      if (levelAttrs.elementType === 'newselect') {
        value = levelAttrs.value?.value
      } else {
        value = levelAttrs.value
      }
      return { ...levelData, [levelKey]: value }
    }, {})
    levelData = {
      ...levelData,
      midpoint: Math.round(parseFloat(levelData.midpoint) * 100) / 100
    }

    if (this.state.action === 'add') {
      this.props.createLevel({ ...levelData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateLevel(
        this.state.actionRecordId,
        { ...levelData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }
  inputChangeHandler = (groupKey, levelKey, event) => {
    const inputGroup = this.state.inputGroups
    const levelItem = inputGroup[levelKey]
    let inputValue = ''

    switch (levelItem.elementType) {
      case 'newselect':
        inputValue = event
        break
      case 'newmultiSelect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !levelItem.value
        break
      default:
        inputValue = event.target.value
        break
    }
    const filterOptions = {
      company_id: this.state.inputGroups.company_id.value?.value,
      appraisal_type_id: this.state.inputGroups.appraisal_type_id.value?.value,
      [levelKey]: inputValue?.value
    }
    if (levelKey === 'company_id') {
      this.props.fetchPositionGroupOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      let position_group_id = inputGroup.position_group_id
      let level_group_id = inputGroup.level_group_id
      this.setState({
        inputGroups: updateObject(inputGroup, {
          level_group_id: {
            ...level_group_id,
            value: {}
          },
          position_group_id: {
            ...position_group_id,
            value: {}
          }
        })
      })
    }
    if (levelKey === 'appraisal_type_id') {
      this.props.fetchParentLevelOptions(filterOptions)
    }
    const { isValid, error } = checkValidity(inputValue, levelItem.validation, levelItem.label)

    const updatedLevelItem = {
      ...levelItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [levelKey]: updatedLevelItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [levelKey]: updatedLevelItem }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteLevel(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchLevel(param)
    this.closeFilterModal()
  }

  render() {
    let levelLabel = <Spinner />
    if (!this.props.modalLoading.length > 0) {
      levelLabel = Object.entries(this.state.inputGroups).map((item, key) => {
        return (
          <Form
            key={key}
            form={item}
            inputChanged={(levelKey, e) => this.inputChangeHandler(key, levelKey, e)}
            formValid={this.state.formIsValid}
          />
        )
      })
    }
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.levelSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.levelSubmitHandler('save')}
        another={() => this.levelSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    let importDisabled = true
    const pagePermission = this.props.pagePermission

    if (pagePermission.is_add && pagePermission.is_edit) {
      importDisabled = false
    }
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ImportModal
          title={this.props.translate('level')}
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.fileChangeHandler}
          fileSubmit={this.fileSubmitHandler}
          selectedFile={this.state.importFile}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('level')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{levelLabel}</div>
        </Modal>
        <Card>
          <CardHeader>
            <ActionBar
              exporting={this.exportHandler}
              importing={this.openImportModal}
              downloading={this.downloadHandler}
              filtering={this.openFilterModal}
              importDisabled={importDisabled}
            />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('level')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.modalLoading.includes('fetchLevel')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.level.pagination,
    data: state.level.records,
    loading: state.level.loading,
    filterLoading: state.level.filterLoading,
    success: state.level.success,
    companyOptions: state.level.company,
    selectedRecord: state.level.selectedRecord,
    levelGroupOptions: state.level.levelGroup,
    appraisalTypeOptions: state.level.appraisalType,
    parentLevelOptions: state.level.parentLevel,
    postionGroupOptions: state.level.positionGroup,
    filterCompany: state.level.filterCompany,
    filterLevel: state.level.filterLevel,
    filterActive: state.level.filterActive,
    filterParentLevel: state.level.filterParentLevel,
    modalLoading: state.level.modalLoadingQueue,
    tagOptions: state.level.tags
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLevel: filterOptions => dispatch(actions.fetchLevel(filterOptions)),
    fetchLevelById: recordId => dispatch(actions.fetchLevelById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedLevelRecord()),
    createLevel: (recordData, page) => dispatch(actions.createLevel(recordData, page)),
    updateLevel: (recordId, recordData, page) =>
      dispatch(actions.updateLevel(recordId, recordData, page)),
    deleteLevel: (recordId, page) => dispatch(actions.deleteLevel(recordId, page)),
    fetchParentLevelOptions: filterOptions => {
      dispatch(actions.fetchParentLevelOptions(filterOptions))
    },
    importLevel: (importFile, filterOptions) =>
      dispatch(actions.importLevel(importFile, filterOptions)),
    exportLevel: filterOptions => dispatch(actions.exportLevels(filterOptions)),
    downloadTemplate: filterOptions => dispatch(actions.downloadLevelTemplate(filterOptions)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalTypeOptions())
      dispatch(actions.fetchParentLevelOptions())
      dispatch(actions.fetchPositionGroupOptions())
      dispatch(actions.fetchLevelGroupOptions())
      dispatch(actions.fetchLevelTags())
    },
    fetchPositionGroupOptions: filter => dispatch(actions.fetchPositionGroupOptions(filter)),
    fetchLevelGroupOptions: filter => dispatch(actions.fetchLevelGroupOptions(filter)),
    fetchFilter: filter => {
      dispatch(actions.fetchAppraisalTypeOptions())
      dispatch(actions.fetchLevelFilterCompany(filter))
      dispatch(actions.fetchLevelFilterLevel(filter))
      dispatch(actions.fetchLevelFilterParentLevel(filter))
      dispatch(actions.fetchLevelFilterActive(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupLevel))
